// Central brand asset registry — the geometric "Arvind bird" is the brand's
// signature illustration language. We reuse the nine variants across the site.
export const BIRDS = {
  bird_hero: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/2q0m5lpn_1.webp",
  bird_flock: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/rwsl3z5h_2.png",
  bird_soar: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/hg193s99_3.webp",
  bird_pop: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/i7f408ov_4.png",
  bird_mark: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/qdhk376h_5.png",
  bird_pair: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/8s6l23o5_6.webp",
  bird_side: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/x3y68z7c_7.webp",
  bird_solo: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/d54x0gwa_8.png",
  bird_composition: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/m63mcls1_9.webp",
};

// Official Arvind Printers brand logos — five variants.
export const LOGO = {
  // Circular "32 YEARS OF PRINTING EXCELLENCE" badge with CMYK+gold rings
  badge_32: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/w1u8b64s_32%20Year%20of%20Printing%20Legacy.png",
  // Horizontal lockup — A-mark + ARVIND PRINTERS + DESIGN | BRAND | PRINT tagline
  horizontal: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/qtb0mr7q_AP%20Logo_2.webp",
  // Vertical stacked lockup with tagline (largest signature usage)
  stacked_tagline: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/ij00l2e4_Logo_1.png",
  // Stacked A-mark + ARVIND PRINTERS wordmark (no tagline)
  stacked: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/06ue678d_AP%20%202.png",
  // Icon-only gradient A-mark
  mark: "https://customer-assets-cm19k8pv.emergentagent.net/job_arvind-print-studio/artifacts/nnkyjb4z_AP%20LOGO.png",
};

export const BIRD_LIST = Object.values(BIRDS);
